import { render, staticRenderFns } from "./CreateAlertModal.vue?vue&type=template&id=2ef6ee4a&"
import script from "./CreateAlertModal.vue?vue&type=script&lang=js&"
export * from "./CreateAlertModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ef6ee4a')) {
      api.createRecord('2ef6ee4a', component.options)
    } else {
      api.reload('2ef6ee4a', component.options)
    }
    module.hot.accept("./CreateAlertModal.vue?vue&type=template&id=2ef6ee4a&", function () {
      api.rerender('2ef6ee4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/notifications/CreateAlertModal.vue"
export default component.exports